import IconCheck from '@/shared/icons/NewDesign/IconCheck'
import PoleIcon from './PoleIcon'
import type { PoleOptionItem } from './usePolePicker'
import { PoleCheck, PoleCount, PoleDivider, PoleIconTile, PoleName, PoleOption } from './styled-components'

interface PolePickerOptionProps {
  option: PoleOptionItem
}

const PolePickerOption = ({ option }: PolePickerOptionProps) => (
  <>
    {option.hasDividerBefore && <PoleDivider role='separator' />}
    <PoleOption
      type='button'
      role='option'
      aria-selected={option.isSelected}
      $selected={option.isSelected}
      onClick={option.onChoose}
    >
      <PoleIconTile $small $onTint={option.isSelected}>
        <PoleIcon id={option.id} size={18} />
      </PoleIconTile>
      <PoleName $selected={option.isSelected}>{option.name}</PoleName>
      <PoleCount>{option.countLabel}</PoleCount>
      <PoleCheck $visible={option.isSelected}>
        <IconCheck size={18} />
      </PoleCheck>
    </PoleOption>
  </>
)

export default PolePickerOption
